// import React from 'react';
import { connect } from 'react-redux';

import ReportTemplatesModal from '../../components/ReportTemplatesModal';
import { fetchReportTemplates } from '../../redux/sagas/report-template/routines';
import {
  getReportTemplatesByFileType,
  getIsFetching
} from '../../redux/selectors/report-template';

function mapStateToProps(state, { fileType }) {
  return {
    ...state,
    templates: getReportTemplatesByFileType(state, fileType),
    isFetchingTemplates: getIsFetching(state)
  };
}

function mapDispatchToProps(dispatch, { fileType }) {
  return {
    getTempates: () => {
      dispatch(fetchReportTemplates({ qs: { fileType } }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportTemplatesModal);
